import { render, staticRenderFns } from "./newBottom.vue?vue&type=template&id=bd7befda&scoped=true"
import script from "./newBottom.vue?vue&type=script&lang=js"
export * from "./newBottom.vue?vue&type=script&lang=js"
import style0 from "./newBottom.vue?vue&type=style&index=0&id=bd7befda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7befda",
  null
  
)

export default component.exports